import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CheckIcon from "@mui/icons-material/Check";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchEmployeeGroups } from "../../../../../store/slices/employeeGroup";

export default function AssignManagers({
  proj,
  row,
  projIndex,
  employees,
  employeeGroups,
  setAssignProjectDetails,
  setConfirmAssignPopup,
  index,
}) {
  const dispatch = useDispatch();
  const [selectedPrimaryResourceList, setSelectedPrimaryResourceList] =
    useState({});
  const [employeesfinalList, setEmployeesfinalList] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [, setSelectedIndex] = useState(null);
  const [assignedPeopleList, setAssignedPeopleList] = useState([]);
  const { groups } = useSelector((state) => state.employeeGroup);

  useEffect(() => {
    const projectKey = `${proj._id}_${proj.TypeService}`;
    if (assignedPeopleList[projectKey]) {
      setAssignProjectDetails({
        emp: assignedPeopleList[projectKey]?.emp?.employeeId,
        proj: proj,
      });
    }
  }, [assignedPeopleList, proj, setAssignProjectDetails]);




  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchEmployeeGroups());
  }, [dispatch]);

  useEffect(() => {
    setEmployeesfinalList(groups);
  }, [groups]);

  const managerDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        managerDropdownRef.current &&
        !managerDropdownRef.current.contains(event.target)
      ) {
        setOpenMenuIdx(null); // close on outside click
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [, setOpenMenuIdx] = useState(null);
  // const [selectedEmpNames, setSelectedEmpNames] = useState({});

  // const [matchedAssignedProject, setMatchedAssignedProject] = useState({});

  // useEffect(() => {
  //   const found = row.managerAssignedProject.find(
  //     (pro) =>
  //       pro.ProjectName === proj.ProjectName &&
  //       pro.TypeService === proj.TypeService
  //   );
  //   setMatchedAssignedProject(found || null);
  // }, [row, proj]);

  // 🟢 Helper: get current manager name (either from state OR default)
  // const getManagerName = (proj) => {
  //   if (selectedEmpNames[proj._id]) {
  //     return selectedEmpNames[proj._id];
  //   }

  //   const defaultEmp = employeeGroups.find(
  //     (group) =>
  //       group.employeeId?.EmpEmail?.toLowerCase() ===
  //       proj.AssignedManagerEmail?.[0]?.toLowerCase()
  //   )?.employeeId;

  //   return defaultEmp
  //     ? `${defaultEmp.EmpFirstName} ${defaultEmp.EmpLastName}`
  //     : "Select";
  // };

  // 🟢 Helper: check if emp is currently selected/highlighted
  // const isEmpSelected = (proj, emp) => {
  //   const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`;
  //   const selectedName = selectedEmpNames[proj._id];

  //   if (selectedName) {
  //     return selectedName === fullName;
  //   }

  //   return (
  //     proj.AssignedManagerEmail?.[0]?.toLowerCase() ===
  //     emp.EmpEmail?.toLowerCase()
  //   );
  // };

  const [filteredEmployees, setFilteredEmployees] = useState([]);

  const resolveGroupId = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    return value?._id || value?.id || "";
  };

  useEffect(() => {
    if (!proj || !employeesfinalList?.length) return;

    const projectGroupId = resolveGroupId(proj.groupid);

    const filtered = employeesfinalList
      .filter(
        (emp) => resolveGroupId(emp.groupId) === projectGroupId
      )
      .filter(
        (emp) =>
          emp.employeeId?.servicetype?.trim().toLowerCase() ===
          proj?.TypeService?.trim().toLowerCase()
      );

    setFilteredEmployees(filtered);
  }, [employeesfinalList, proj]);

  const matchedManager = filteredEmployees.find(
    (emp) => emp.employeeId?.EmpEmail === proj.AssignedManagerEmail?.[0]
  );

  return (
    <>
      {/* <div className=" m-auto flex">
        <div
          ref={managerDropdownRef}
          className=" w-[85%]  relative flex p-0 rounded-xl align-top items-center"
        >
          <button
            type="button"
            onClick={(e) => {
              if (matchedAssignedProject) return; // Don't open menu if already assigned
              e.stopPropagation();
              const menuKey = `${projIndex}_${proj.TypeService}_${proj._id}`;
              setOpenMenuIdx((prev) => (prev === menuKey ? null : menuKey));
            }}
            disabled={!!matchedAssignedProject}
            className={`relative w-auto border text-[11px] rounded-md p-1 text-start overflow-hidden outline-none ${
              matchedAssignedProject ? "cursor-not-allowed bg-blue-200" : ""
            }`}
          >
            {matchedAssignedProject
              ? matchedAssignedProject.Assignedperson?.find((person) =>
                  employees.some(
                    (emp) =>
                      emp.EmpEmail === person.email &&
                      emp.customRoles?.includes("project manager")
                  )
                )?.name || getManagerName(proj)
              : getManagerName(proj)}

            {!matchedAssignedProject && (
              <ExpandMoreIcon className="absolute top-1 right-0 bg-white" />
            )}
          </button>

          {openMenuIdx === `${projIndex}_${proj.TypeService}_${proj._id}` && (
            <div
              style={{ zIndex: 9999 }}
              className="absolute top-full left-0 w-full p-1 bg-white text-xs border shadow-lg flex flex-col gap-1"
            >
              {employeeGroups
                .filter(
                  (group) =>
                    group?.employeeId &&
                    group.employeeId.servicetype === proj.TypeService &&
                    Array.isArray(group.employeeId.customRoles) &&
                    group.employeeId.customRoles.includes("project manager")
                )
                .map((group) => {
                  const emp = group.employeeId;
                  const selected = isEmpSelected(proj, emp);

                  return (
                    <div
                      key={emp._id}
                      className={`z-50 p-1 text-start cursor-pointer text-[12px] hover:bg-blue-100 ${
                        selected ? "bg-blue-200 font-semibold" : ""
                      }`}
                      onClick={() => {
                        setAssignProjectDetails({ proj, emp });

                        // 🟢 Update selected name
                        setSelectedEmpNames((prev) => ({
                          ...prev,
                          [proj._id]: `${emp.EmpFirstName} ${emp.EmpLastName}`,
                        }));

                        setConfirmAssignPopup(true);
                        setOpenMenuIdx(null);
                      }}
                    >
                      {emp.EmpFirstName} {emp.EmpLastName}
                    </div>
                  );
                })}
            </div>
          )}
        </div>

        <div className="flex w-[15%] justify-center items-center">
          {(matchedAssignedProject?.Assignedperson?.find((person) =>
            employees.some(
              (emp) =>
                emp.EmpEmail === person.email &&
                emp.customRoles?.includes("project manager")
            )
          )?.salespersonaction ||
            matchedAssignedProject?.Assignedperson?.[0]?.salespersonaction) ===
            "assigned" && (
            <span
              title="Pending"
              className="text-orange-500 text-xl font-bold px-1 ml-2 rounded"
            >
              !
            </span>
          )}

          {(matchedAssignedProject?.Assignedperson?.find((person) =>
            employees.some(
              (emp) =>
                emp.EmpEmail === person.email &&
                emp.customRoles?.includes("project manager")
            )
          )?.salespersonaction ||
            matchedAssignedProject?.Assignedperson?.[0]?.salespersonaction) ===
            "completed" && (
            <span
              title="Submitted"
              className="text-green-600 text-xl font-bold  px-1 ml-2 rounded"
            >
              <CheckIcon className=" text-green-600" />
            </span>
          )}
        </div>
      </div> */}

      <div className="flex w-full border-r pt-1 justify-center align-middle items-center">
        {proj.Assignedperson.some(
          (person) =>
            person.salespersonstatus === "project approved" &&
            person.managerstatus === "project assigned"
        )
          ? <>
            <div className="w-[80%] max-w-20 rounded-md relative flex justify-center text-xs align-middle items-center ">
              <button >
                {proj.Assignedperson.find(
                  (person) =>
                    person.salespersonstatus === "project approved" &&
                    person.managerstatus === "project assigned"
                )?.name || "Select Option"}
              </button>
              {(proj?.Assignedperson?.find((person) =>
                employees.some(
                  (emp) =>
                    emp.EmpEmail === person.email &&
                    emp.customRoles?.includes("project manager")
                )
              )?.projecttracktaskStatus) ===
                "pending" && (
                  <span
                    title="Pending"
                    className="text-orange-500 text-xl font-bold px-1 ml-2 rounded"
                  >
                    !
                  </span>
                )}
            </div>
          </>
          : <>
            <div className="w-[80%] max-w-20 rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300">
              <button
                onClick={() => {
                  setOpenDropdownIndex(openDropdownIndex === index ? null : index);
                  setSelectedIndex(index);
                }}
                className="w-full text-xs px-2 py-2 truncate flex justify-between items-center max-w-26 "
              >
                {/* {assignedPeopleList[index]?.length > 0
              ? assignedPeopleList[index].map((item) => item.name).join(", ")
              : "Resources"} */}
                {matchedManager
                  ? `${matchedManager.employeeId?.EmpFirstName} ${matchedManager.employeeId?.EmpLastName}`
                  : "Select Resource"}

              </button>

              <ExpandMoreIcon
                onClick={() =>
                  setOpenDropdownIndex(openDropdownIndex === index ? null : index)
                }
                className="ml-1 absolute right-0 cursor-pointer bg-white group-hover:bg-gray-100"
              />

              {openDropdownIndex === index && (
                <div className="absolute top-full left-0  max-w-26 max-h-52 overflow-y-auto bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar">
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees
                      .map((emp) => {
                        const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                        const empEmail = emp.employeeId?.EmpEmail;
                        // const isAssigned = assignedPeopleList[index]?.some(
                        //   (item) => item.email === empEmail
                        // );
                        const projectKey = `${proj._id}_${proj.TypeService}`;
                        const isAssigned = assignedPeopleList[projectKey]?.email === empEmail;

                        return (
                          <label
                            key={emp.employeeId?.id || emp.employeeId?._id}
                            className={`flex justify-between align-middle items-center px-2 py-1 text-xs ${proj.AssignedManagerEmail?.[0] === empEmail
                              ? "bg-blue-300 font-semibold"
                              : "bg-white hover:bg-gray-100"
                              }`}                      >


                            <input
                              type="checkbox"
                              className="mr-2"
                              value={fullName}
                              checked={assignedPeopleList[projectKey]?.email === empEmail} // use the dynamic key
                              onChange={(e) => {
                                const selectedValue = { name: fullName, email: empEmail, emp: emp };
                                const isChecked = e.target.checked;

                                setAssignedPeopleList((prev) => {
                                  if (isChecked) {
                                    return { ...prev, [projectKey]: selectedValue };
                                  } else {
                                    const newState = { ...prev };
                                    delete newState[projectKey];
                                    return newState;
                                  }
                                });
                              }}
                            />

                            {fullName}
                            <input
                              title="Select Primary Resource"
                              className="primaryselector"
                              type="checkbox"
                              checked={selectedPrimaryResourceList[projectKey] === empEmail}
                              disabled={!isAssigned} // Disable if not in assigned list
                              onChange={() => {
                                if (isAssigned) {
                                  setSelectedPrimaryResourceList((prev) => ({
                                    ...prev,
                                    [projectKey]: prev[projectKey] === empEmail ? null : empEmail,
                                  }));
                                }
                              }}
                            />
                          </label>
                        );
                      })
                  ) : (
                    <div className="px-2 py-1 text-gray-500">
                      No matching resources found.
                    </div>
                  )}
                </div>
              )}

            </div>
          </>}

      </div>
    </>
  );
}

/** Same JSON body used for POST /project-assigned (Forward) and POST /project-assigned/direct-accept (Accept). */
export function buildSalespersonProjectApprovedAssignPayload(proj, matchedEntry, employees) {
  const reAssignEmp = employees?.find(
    (emp) => emp.EmpEmail === proj?.AssignedManagerEmail?.[0]
  );
  return {
    projectName: proj?.ProjectName,
    quotationId: proj?.quotationId,
    serviceType: proj?.TypeService,
    projectId: proj?._id,
    targetManagerId: matchedEntry?.emp?.employeeId?._id || reAssignEmp?._id,
  };
}
